import React, { useState } from "react";
import InputMask from "react-input-mask";
import { useForm, Controller } from "react-hook-form"

import { db, store } from "services/firebase";
import { zeroFill } from "utils/string";

import { createPreference } from "services/mercadopago.service";

export default function Form() {
    const [loading, setLoading] = useState(false);

    const { watch, control, register, formState: { errors }, handleSubmit } = useForm();

    const onSubmit = async (data) => {
        setLoading(true);

        delete data.email_confirmacao;

        let ticketCount = undefined;
        let ticketId = undefined;

        try {
            // get ticket count from realtime database
            await db.ref("ingressos").get().then((snapshot) => {
                ticketCount = snapshot.val();
                ticketId = `I${zeroFill((ticketCount + 1), 4)}`;
            })

            // update ticket count
            await db.ref("ingressos").set(ticketCount + 1);


            // send request to mercado pago
            const res_mercadopago = await createPreference(data);

            // get mercado pago payment link
            const link = res_mercadopago.data.init_point;

            const ticketData = {
                ...data,
                ticketId,
                paymentLink: link,
                status: "PENDENTE",
            }

            // store data at firestore 
            await store.collection('INGRESSOS').doc(ticketId).set(ticketData);

            // redirect page
            location.href = link;
        } catch (error) {
            console.log(error);
            alert("Houve um erro, tente novamente mais tarde!")
        }

        setLoading(false);
    };

    const renderTicketsForm = (
        <>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label>Nome</label>
                    <input
                        className="form-control"
                        placeholder="Nome"
                        defaultValue={""}
                        {...register(`nome`, {
                            required: true,
                            minLength: 2,
                            maxLength: 26,
                        })}
                    />
                    {errors.nome?.type === "required" && (
                        <small>Nome é obrigatório</small>
                    )}
                    {errors.nome?.type === "minLength" && (
                        <small>O nome deve ter pelo menos 2 caracteres</small>
                    )}
                    {errors.nome?.type === "maxLength" && (
                        <small>O nome deve ter menos que 26 caracteres</small>
                    )}
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label>WhatsApp</label>
                    <Controller
                        name={`telefone`}
                        control={control}
                        defaultValue={""}
                        rules={{
                            required: true,
                            pattern: /\([0-9]{2}\) [0-9]{5}-[0-9]{4}/g,
                        }}
                        render={({ field }) => (
                            <InputMask
                                {...field}
                                type="tel"
                                className="form-control"
                                mask="(99) 99999-9999"
                                placeholder="(__) _____-____"
                            />
                        )}
                    />
                    {errors.telefone?.type === "required" && (
                        <small>Telefone é obrigatório</small>
                    )}
                    {errors.telefone?.type === "pattern" && (
                        <small>Telefone inválido</small>
                    )}
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label>Email</label>
                    <input
                        type="email"
                        className="form-control"
                        placeholder="exemplo@email.com"
                        defaultValue={""}
                        {...register("email", {
                            required: true,
                            pattern: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/g,
                        })}
                    />
                    {errors.email?.type === "required" && (
                        <small>Email é obrigatório</small>
                    )}
                    {errors.email?.type === "pattern" && (
                        <small>O email deve estar no formato correto</small>
                    )}
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label>Confirmar Email</label>
                    <input
                        type="email"
                        className="form-control"
                        placeholder="exemplo@email.com"
                        defaultValue={""}
                        {...register("email_confirmacao", {
                            required: true,
                            pattern: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/g,
                            validate: {
                                match: (value) => watch("email") === value,
                            },
                        })}
                    />
                    {errors.email_confirmacao?.type === "required" && (
                        <small>Email é obrigatório</small>
                    )}
                    {errors.email_confirmacao?.type === "pattern" && (
                        <small>O email deve estar no formato correto</small>
                    )}
                    {errors.email_confirmacao?.type === "match" && (
                        <small>Os emails não são iguais</small>
                    )}
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label>Cargo</label>
                    <input
                        className="form-control"
                        placeholder="Cargo"
                        defaultValue={""}
                        {...register("cargo", {
                            required: true,
                            minLength: 2,
                            maxLength: 50,
                        })}
                    />
                    {errors.cargo?.type === "required" && (
                        <small>Nome do cargo é obrigatório</small>
                    )}
                    {errors.cargo?.type === "minLength" && (
                        <small>
                            O nome do cargo deve ter pelo menos 2 caracteres
                        </small>
                    )}
                    {errors.cargo?.type === "maxLength" && (
                        <small>
                            O nome do cargo deve ter menos que 50 caracteres
                        </small>
                    )}
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label>Empresa</label>
                    <input
                        className="form-control"
                        placeholder="Empresa"
                        defaultValue={""}
                        {...register("empresa", {
                            required: true,
                            minLength: 2,
                            maxLength: 50,
                        })}
                    />
                    {errors.empresa?.type === "required" && (
                        <small>Nome da empresa é obrigatório</small>
                    )}
                    {errors.empresa?.type === "minLength" && (
                        <small>
                            O nome da empresa deve ter pelo menos 2 caracteres
                        </small>
                    )}
                    {errors.empresa?.type === "maxLength" && (
                        <small>
                            O nome da empresa deve ter menos que 50 caracteres
                        </small>
                    )}
                </div>
            </div>
        </>
    );

    return (
        <section className="py-3">
            <div className="container text-center">
                <h2>Peça aqui seu ingresso para a CyberSecGO</h2>
            </div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row mb-3">
                                {renderTicketsForm}
                            </div>
                            <div className="row justify-content-end align-items-center">
                                <div className="col-12 col-md-4">
                                    {loading ? (
                                        <button className="btn btn-primary btn-block" disabled>
                                            <span className="spinner-border spinner-border-sm" />
                                        </button>
                                    ) : (
                                        <button type="submit" className="btn btn-primary btn-block">
                                            Comprar ingresso
                                        </button>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}
